import { Autocomplete, Box, Button, Paper, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Title from "../../../components/common/Title";

/**
 * Component for the Competitor JSON section with internal handlers
 * @param {Object} props - Component props
 * @param {Array} props.companyNames - List of available company names
 * @param {Object} props.competitorData - Current competitor data state
 * @param {Function} props.onChangeState - Handler for updating competitor data state
 * @param {Function} props.onSubmit - Handler for submit button click
 */
function Competitors({ companyNames, competitorData, onChangeState, onSubmit }) {
  // Handler to update competitor data state in parent component
  const handleFieldChange = (field) => (e, value) => {
    onChangeState({ ...competitorData, [field]: value });
  };

  return (
    <Grid container direction="column" spacing={4} p={3} mx={"10%"}>
      {/* Company Selection Section */}
      <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
        <Title text="Competitor JSON" sx={{ mb: 4, textAlign: "center" }} />

        <Autocomplete
          options={companyNames}
          renderInput={(params) => <TextField {...params} label="Select Company" />}
          onChange={handleFieldChange("company")}
          getOptionLabel={(option) => option}
          value={competitorData.company}
          sx={{ width: "100%" }}
        />

        {/* Submit Button Section */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Button variant="outlined" color="primary" size="large" onClick={onSubmit} sx={{ px: 4, py: 1 }}>
            Submit
          </Button>
        </Box>
      </Paper>
    </Grid>
  );
}

export default Competitors;
